var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',[_c('v-card',[(_vm.userActions && _vm.userCompliance)?_c('highcharts',{attrs:{"options":_vm.userActionsReport}}):_vm._e()],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }